var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "transcript-sentiment-card az-card-bordered no-padding no-shadow d-flex flex-column flex-sm-row",
      style: _vm.cardStyle
    },
    [
      _c(
        "div",
        {
          staticClass:
            "transcript-sentiment-card__content d-flex align-center az-gap pa-4 flex-grow-1"
        },
        [
          _c("IconWithBackground", {
            staticClass: "flex-shrink-0",
            attrs: {
              rounded: "",
              icon: _vm.iconName,
              "container-size": 48,
              "icon-size": 28,
              color: _vm.accentToken,
              opacity: 0.15
            }
          }),
          _c("div", { staticClass: "d-flex flex-column az-gap-xxsmall" }, [
            _c(
              "span",
              { staticClass: "az-ds-card-title", style: _vm.titleStyle },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _c("span", { staticClass: "az-ds-body" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ]),
            _vm.alinhamentoLabel
              ? _c("span", { staticClass: "az-ds-aux" }, [
                  _vm._v(" " + _vm._s(_vm.alinhamentoLabel) + " ")
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "transcript-sentiment-card__score d-flex flex-column align-center justify-center flex-shrink-0 px-6 py-4",
          style: _vm.scoreStyle
        },
        [
          _c("span", { staticClass: "d-flex align-baseline" }, [
            _c(
              "span",
              { staticClass: "az-ds-kpi", style: { color: _vm.notaColor } },
              [_vm._v(" " + _vm._s(_vm.notaFormatada) + " ")]
            ),
            _vm.hasScore
              ? _c(
                  "span",
                  { staticClass: "az-ds-aux", style: { color: _vm.notaColor } },
                  [_vm._v(" " + _vm._s(_vm.scoreSuffix) + " ")]
                )
              : _vm._e()
          ]),
          _c("span", { staticClass: "az-ds-label" }, [_vm._v("Nota")])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }